module.exports = __webpack_public_path__ + "static/media/arolas.826dc8c0.png";